import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    isSmallWindowWidth: true,
    isVerySmallWindowWidth: true,
    os: 'NONE',
    mode: undefined,
    mapupdateInformation: undefined,
    country: undefined,
    language: undefined,
    vin: undefined,
    jweAvailable: false,
    model: undefined,
    oneWebNtg: undefined,
    supportLink: undefined,
    baseURL: undefined,
    overview: {
      labelOtaRegionHovered: false,
      labelUpToDateRegionHovered: false,
      labelOutdatedRegionHovered: false,
      map: {
        specificOtaRegionHovered: false,
        specificUpToDateRegionHovered: false,
        specificOutdatedRegionHovered: false,
      },
    },
    otaChange: {
      selectedRegion: undefined,
    },
    manualUpdate: {
      browserModeActive: false,
      mode: 'dlm',
      step: 0,
      completeMapSelected: false,
      selectedRegions: [],
    },
    error: undefined,
    errorDescription: '',
    analyticsData: {
      userAgent: '',
      componentRegistry: {},
      wko: {},
      wkoB2B: {},
      searchParams: {},
    },
  },
  mutations: {
    calculateSmallWindowWidth(state, windowWidth) {
      if (windowWidth > 1000) {
        state.isSmallWindowWidth = false;
      } else {
        state.isSmallWindowWidth = true;
      }
      if (windowWidth > 500) {
        state.isVerySmallWindowWidth = false;
      } else {
        state.isVerySmallWindowWidth = true;
      }
    },
    setOS(state, os) {
      state.os = os;
    },
    setBaseURL(state, baseURL) {
      state.baseURL = baseURL;
    },
    setLanguage(state, language) {
      if (language !== undefined && language !== '') {
        state.language = language;
      }
    },
    setCountry(state, country) {
      if (country !== undefined && country !== '') {
        state.country = country;
      }
    },
    setVin(state, vin) {
      if (vin !== undefined && vin !== '') {
        state.vin = vin;
      }
    },
    setModel(state, model) {
      if (model !== undefined && model !== '' && model !== ' ') {
        state.model = model;
      }
    },
    setOneWebNtg(state, oneWebNtg) {
      if (oneWebNtg !== undefined && oneWebNtg !== '') {
        state.oneWebNtg = oneWebNtg;
      }
    },
    setSupportLink(state, supportLink) {
      if (supportLink !== undefined && supportLink !== '') {
        state.supportLink = supportLink;
      }
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setLabelOtaRegionHovered(state, hovered) {
      state.overview.labelOtaRegionHovered = hovered;
    },
    setLabelUpToDateRegionHovered(state, hovered) {
      state.overview.labelUpToDateRegionHovered = hovered;
    },
    setLabelOutdatedRegionHovered(state, hovered) {
      state.overview.labelOutdatedRegionHovered = hovered;
    },
    setSpecificOtaRegionHovered(state, hovered) {
      state.overview.map.specificOtaRegionHovered = hovered;
    },
    setSpecificUpToDateRegionHovered(state, hovered) {
      state.overview.map.specificUpToDateRegionHovered = hovered;
    },
    setSpecificOutdatedRegionHovered(state, hovered) {
      state.overview.map.specificOutdatedRegionHovered = hovered;
    },
    setMapupdateInformation(state, mapupdateInformation) {
      state.mapupdateInformation = mapupdateInformation;
      state.manualUpdate.selectedRegions = state.mapupdateInformation.mapRegions.filter(
        (r) => r.selectedOTARegion && !r.upToDate,
      );
    },
    setManualUpdateStep(state, step) {
      state.manualUpdate.step = step;
    },
    setManualUpdateMode(state, mode) {
      state.manualUpdate.mode = mode;
      if (mode === 'browser') {
        state.manualUpdate.completeMapSelected = true
      }
      if (mode === 'dlm') {
        state.manualUpdate.completeMapSelected = false
      }
    },
    activateBrowserDownload(state) {
      state.manualUpdate.browserModeActive = true;
    },
    setOtaChangeSelectedRegion(state, mapRegion) {
      if (mapRegion && mapRegion.selectedOTARegion) {
        state.otaChange.selectedRegion = undefined;
      } else {
        state.otaChange.selectedRegion = mapRegion;
      }
    },
    resetOtaChangeSelectedRegion(state) {
      state.otaChange.selectedRegion = undefined;
    },
    setSelectedOtaRegionInMapUpdateInformation(state, selectedOtaRegionId) {
      let m = JSON.parse(JSON.stringify(state.mapupdateInformation));
      m.mapRegions.map((mapRegion) => (mapRegion.selectedOTARegion = false));
      m.mapRegions.map((mapRegion) => {
        if (mapRegion.regId === selectedOtaRegionId) {
          mapRegion.selectedOTARegion = true;
        }
      });
      state.mapupdateInformation = m;
    },
    updateCompleteMapSelected(state, completeMapSelected) {
      state.manualUpdate.completeMapSelected = completeMapSelected;
    },
    toggleManualUpdateSelectedRegion(state, mapRegion) {
      if (state.manualUpdate.selectedRegions.find((r) => r.regId === mapRegion.regId)) {
        state.manualUpdate.selectedRegions = state.manualUpdate.selectedRegions.filter(
          (r) => r.regId !== mapRegion.regId,
        );
      } else {
        state.manualUpdate.selectedRegions.push(mapRegion);
      }
    },
    resetManualUpdateSelectedRegions(state) {
      state.manualUpdate.selectedRegions = state.mapupdateInformation.mapRegions.filter(
        (r) => r.selectedOTARegion && !r.upToDate,
      );
    },
    setError(state, error) {
      state.error = error;
    },
    setErrorDescription(state, error) {
      state.errorDescription = error;
    },
    setJweAvailable(state, jweAvailable) {
      if (!state.jweAvailable) {
        state.jweAvailable = jweAvailable;
      }
    },
    setUserAgent(state, userAgent) {
      state.analyticsData.userAgent = userAgent;
    },
    setComponentRegistry(state, componentRegistry) {
      state.analyticsData.componentRegistry = componentRegistry;
    },
    setWko(state, wko) {
      wko.User.personal = { name: 'anonymizedUserData' };
      wko.User.associatedDealers = {};
      state.analyticsData.wko = wko;
    },
    setWkoB2B(state, wkoB2B) {
      wkoB2B.user = { firstName: 'anonymizedUserData' }; //anonymize user
      state.analyticsData.wkoB2B = wkoB2B;
    },
    setSearchParams(state, searchParams) {
      state.analyticsData.searchParams = searchParams;
    },
  },
  getters: {
    isOneWebNtg7(state) {
      return state.oneWebNtg === '7';
    },
    getSelectedOtaRegion(state) {
      if (!state.mapupdateInformation) {
        return undefined;
      }
      return state.mapupdateInformation.mapRegions.find((mr) => mr.selectedOTARegion);
    },
    isOtaChangePossible(state, getters) {
      if (!state.mapupdateInformation) {
        return false;
      }
      let otaChangePossible = state.mapupdateInformation.mapRegions.some(
        (mr) => mr.otaUpdatePossible && !mr.selectedOTARegion,
      );
      return (getters.isDownloadManagerFeasible || otaChangePossible) && state.mapupdateInformation.otaSupportEnabled;
    },
    isLivemapSupportEnabled(state) {
      if (state.mapupdateInformation) {
        return state.mapupdateInformation.livemapSupportEnabled;
      }
      return false;
    },
    isOtaSupportEnabled(state) {
      if (state.mapupdateInformation) {
        return state.mapupdateInformation.otaSupportEnabled;
      }
      return false;
    },
    isDownloadManagerFeasible(state) {
      return state.os.toUpperCase() === 'WIN' || state.os.toUpperCase() === 'MAC';
    },
    isMapEnabled(state, getters) {
      return !getters.isMapDisabled;
    },
    isMapDisabled(state) {
      return state.country === 'NOMAP';
    },
  },
});
